import { TextInputTemplateProps } from "@graffer-inc/form-generator";

export const NotificationNumberInput: React.FC<TextInputTemplateProps> = ({
  config,
  value,
}) => {
  const strValue = value?.toString();
  return <p data-elem-id={config.formFieldId}>{strValue}</p>;
};
